import _ from 'lodash'
import Vue from 'vue'

export default {
    initDefaultFields(state, key) {
        Vue.set(state, key, {
            idenfoId: null,
            dataSegmentId: null,
            recieveOtpOption: [],
            otpCode: null,
            languageOption: null,
            pmd: {
                recievePmdaOption: null,
                pmdVerificationStatus: null,
                pmdInfo: {
                    idType: null,
                    idNumber: null,
                    isdCode: null,
                    phoneNumber: null,
                },
            },
            basicInfo: {
                tempId: null,
                firstName: null,
                middleName: '',
                lastName: '',
                genderId: null,
                gender: '',
                dateOfBirth: null,
                nationalityId: null,
                nationality: null,
                countryOfResidenceId: null,
                countryOfResidence: null,
                //
                fatherOrHusbandName: null,
                motherName: null,
                placeOfBirth: null,
                religion: null,
                religionId: null,
                zakatId: null,
                zakat: null,
                maritalStatus: null,
                maritalStatusId: null,
                // ntn: null,
                taxStatus: null,
                otherNationalities: null,
                // hasOtherNationalities: null,
                residentialStatus: null,
                permPakResident: null,
                permPakResidentId: null,
                kycNationality: null,
                hasOtherNationalities: null,
                refCode: null,
                isMinorAccount: null,
                isMinorAccountId: null
            },
            identityInfo: {
                type: null,
                number: null,
                expiryDate: null,
                //
                IssuanceDate: null,
                isLifetimeExpiry: null,
            },
            occupationInfo: {
                workTypeId: null,
                workType: null,
                industryId: null,
                industry: null,
                taxId: null,
                //
                // taxNo: null,
                education: null,
                occupation: null,
                occupationId: null,
                taxNo: null,
                sourceOfFunds: null,
                sourceOfFundsId: null,
                businessNature: null,
                geographies: null,
                geographiesOther: null,
                counterParties: null,
                counterPartiesOthers: null,
            },
            contactInfo: {
                address: null,
                address2: null,
                stateId: null,
                state: '',
                cityId: null,
                city: '',
                postalCode: null,
                isdCode: null,
                countryCodeForCodeOnly: null,
                phoneNumber: null,
                email: null,
                //
                greenCardUS: null,
                residentUS: null,
                taxResident: null,
                businessAddress: null,
                phoneRes: null,
                phoneOffice: null,
                fax: null,
                phoneWhatsApp: null,
                whatsappIsdCode: null,
            },
            accountInfo: {
                purposeOfActionId: null,
                purposeOfAction: '',
                products: [],
                expectedCredit: null,
                creditLimit: null,
                grossIncome: null,
                grossIncomeId: null,
                monthlyIncome: null,
                monthlyIncomeId: null,
                initialBalance: null,
                //
                guardianName: null,
                guardianRelationship: null,
                guardianCNIC: null,
                guardianIssuanceDate: null,
                guardianExpiryDate: null,
                guardianMobileNo: null,
                receiveAccountStatement: null,
                mailNature: null,
                mailNatureMisc: null,
                nomineeName1: null,
                nomineeFatherName1: null,
                nomineeMotherName1: null,
                nomineeRelationship1: null,
                nomineeRelationship1Id: null,
                nomineeCNIC1: null,
                nomineeIssuanceDate1: null,
                nomineeExpiryDate1: null,
                nomineeDateOfBirth1: null,
                nomineeReligion1: null,
                nomineeMaritalStatus1: null,
                nomineeNationalityId1: null,
                nomineeNationality1: null,
                nomineePermPakResident1: null,
                nomineeAddress1: null,
                nomineeStateId1: null,
                nomineeState1: null,
                nomineeEmail1: null,
                nomineePhone1: null,
                nomineeAllocation1: null,
                nomineeName2: null,
                nomineeRelationship2: null,
                nomineeCNIC2: null,
                nomineeIssuanceDate2: null,
                nomineeExpiryDate2: null,
                nomineeAllocation2: null,
                jointAHName: null,
                jointAHAddress: null,
                jointAHFatherOrHusbandName: null,
                jointAHCNIC: null,
                jointAHHoldingPerc: null,
                bankTitle: null,
                bankName: null,
                bankId: null,
                bankAccNo: null,
                bankAccountNo: null,
                bankBranch: null,
                bankBranchCode: null,
                bankAddress: null,
                bankIBAN: null,
                internetBankingId: null,
                internetBanking: null,
                operateAccount: null,
                operateAccountOther: null,
                cashDividend: null,
                stockDividend: null,
                stockDividendId: null,
                hearUs: null,
                natureBusinessRelation: null,
                deliveryChannels: null,
                deliveryChannelsId: null,
                expectedTransactions: null,
                expectedTurnover: null,
                declarationCustomer1: null,
                declarationCustomer2: null,
                declarationCustomer3: null,
                declarationCustomer4: null,
                ultimateBenName: null,
                ultimateBenRelation: null,
                ultimateBenIdNo: null,
            },
            documentInfo: {
                digitalSignature: {
                    fileName: null,
                    originalFileName: null,
                },
                cnicBack: {
                    fileName: null,
                    originalFileName: null,
                },
                utility: {
                    fileName: null,
                    originalFileName: null,
                },
                identity: {
                    fileName: null,
                    originalFileName: null,
                },
                video: {
                    fileName: null,
                    originalFileName: null,
                },
                sourceOfIncome: {
                    fileName: null,
                    originalFileName: null,
                },
                nomineeCNIC: {
                    fileName: null,
                    originalFileName: null,
                },
                w9Form: {
                    fileName: null,
                    originalFileName: null,
                },
                zakatAffidavit: {
                    fileName: null,
                    originalFileName: null,
                },
                w8Form: {
                    fileName: null,
                    originalFileName: null,
                },
                businessProof: {
                    fileName: null,
                    originalFileName: null,
                },
                pmdaRelativeForm: {
                    fileName: null,
                    originalFileName: null,
                },
                pmdaCompanyForm: {
                    fileName: null,
                    originalFileName: null,
                },
                fatcaForm: {
                    fileName: null,
                    originalFileName: null,
                },
                crsForm: {
                    fileName: null,
                    originalFileName: null,
                },
            },
            pepInfo: {
                declarationPEP1: null,
                declarationPEP2: null,
                declarationPEP3: null,
                declarationPEP4: null,
                declarationPEP5: null,
                declarationPEP6: null,
                declarationPEP7: null,
                declarationPEP8: null,
                nameUBO: null,
                cnicUBO: null,
                declarationPEP9: null,
                declarationPEP10: null,
            },
            fatcaInfo: {
                titleOfAcc: null,
                CNICNumber: null,
                countryOfResidenceId: null,
                countryOfResidence: null,
                countryOfIncorpId: null,
                countryOfIncorp: null,
                CountryResidentOption: null,
                CountryResident: null,
                CountryResidentTitle: null,
                CountryTaxOption: null,
                CountryTax: null,
                CountryTaxTitle: null,
                dualNational: null,
                dualNationalCountry: null,
                dualNationalCountryTitle: null,
                isUSEntity: null,
                placeOfBirth: null,
                isUSCitizen: null,
                isUSResident: null,
                greenCardUS: null,
                transferInstructions: null,
                IsPowerAttorney: null,
                PowerAttorneyAdd: null,
                isMailAddress: null,
                isUSTelephone: null,
                USIdNumber: null,
                declaration: null,
            },
            customInfo: {},
            investmentProduct: {
                disclaimer: false,
                score: null,
                tolerance: null,
                selectOptions: [],
                selectedProducts: [],
                selectedProductsNames: [],
                recommendedRisk: {
                    title: null,
                },
                secpProduct: null,
            },
            crsInfo: {
                crsCountryTax1: null,
                crsCountryTaxTitle1: null,
                crsTIN1: null,
                crsReason1: null,
                crsOtherReason1: null,
                crsCountryTax2: null,
                crsCountryTaxTitle2: null,
                crsTIN2: null,
                crsReason2: null,
                crsOtherReason2: null,
                crsCountryTax3: null,
                crsCountryTaxTitle3: null,
                crsTIN3: null,
                crsReason3: null,
                crsOtherReason3: null,
            },
            w9Info: {
                fullName: null,
                businessName: null,
                federalTax: null,
                payeeCode: null,
                fatcaCode: null,
                address: null,
                cityId: null,
                city: null,
                stateId: null,
                state: null,
                zipCode: null,
                accountNumber: null,
                tin: null,
            },
            asaanAccInfo: {
                bank: null,
                city: null,
                region: null,
                country: null,
                zakatDeduction: null,
                religion: null,
                gender: null,
                internetBanking: null,
                monthlyIncome: null,
                incomeSource: null,
                dividendInstruction: null,
                maritalStatus: null,
                resident: null,
                occupation: null,
            },
            regAccInfo: {
                bank: null,
                city: null,
                region: null,
                country: null,
                nationality: null,
                zakatDeduction: null,
                religion: null,
                gender: null,
                incomeSource: null,
                dividendInstruction: null,
                maritalStatus: null,
                resident: null,
                occupation: null,
                annualIncome: null,
                pepsInfo: null,
                mobileRegisteredWith: null,
                fatcaInfo: null,
                expInvestAmountBrackets: null,
                accountType: null,
                minor: null,
                title: null,
                retirementAge: null,
                relationWithPrinciple: null,
                transMode: null,
                expectedTurnoverInAccType: null,
                taxResCountriesOtherThanPak: null,
            },
            pmdaForm: {
                valid: false,
                name: 'PMDA',
            },
            ssaForms: {
                form1: {
                    valid: false,
                    routeName: 'identity-document',
                    name: 'Identity Document',
                },
                form2: {
                    valid: false,
                    routeName: 'setup-profile',
                    name: 'Setup Profile',
                },

                // form3: {
                //     valid : false,
                //     routeName : 'additional-info',
                //     name : "Additional Info"
                // },
                form3: {
                    valid: false,
                    routeName: 'kyc',
                    name: 'KYC',
                },
                form4: {
                    valid: false,
                    routeName: 'investment',
                    name: 'Investment',
                },

                form5: {
                    valid: false,
                    routeName: 'risk-product',
                    name: 'Risk Product',
                },

                form6: {
                    valid: false,
                    routeName: 'upload-document',
                    name: 'Upload Document',
                },
            },

            rcForms: {
                form1: {
                    valid: false,
                    routeName: 'identity-document',
                    name: 'Identity Document',
                },
                form2: {
                    valid: false,
                    routeName: 'setup-profile',
                    name: 'Setup Profile',
                },

                form3: {
                    valid: false,
                    routeName: 'account-info',
                    name: 'Account Info',
                },
                form4: {
                    valid: false,
                    routeName: 'kyc',
                    name: 'KYC',
                },
                form5: {
                    valid: false,
                    routeName: 'investment',
                    name: 'Investment',
                },

                form6: {
                    valid: false,
                    routeName: 'risk-product',
                    name: 'Risk Product',
                },

                form7: {
                    valid: false,
                    routeName: 'upload-document',
                    name: 'Upload Document',
                },
            },
        })
        state.isIndustrial = true
        state.isTaxIdRequired = false
    },
    initCustomField(state, { key, value }) {
        Vue.set(state.form.customInfo, key, value)
    },
    updateField(state, payload) {
        _.set(state.form, payload.key, payload.value)
    },
    setValue(state, { key, value }) {
        state[key] = value
    },
}
